"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSvgPathToLineChains = void 0;
exports.parsePcbShape = parsePcbShape;
exports.parseSymbolShape = parseSymbolShape;
exports.parseSchematicShape = parseSchematicShape;
exports.parseEasyEdaJson = parseEasyEdaJson;
const svgPathParser_1 = require("./svgPathParser");
Object.defineProperty(exports, "parseSvgPathToLineChains", { enumerable: true, get: function () { return svgPathParser_1.parseSvgPathToLineChains; } });
const types_1 = require("./types");
function parseDocType(value) {
    if (typeof value === "string") {
        const num = parseInt(value, 10);
        if (!isNaN(num)) {
            return num;
        }
    }
    if (typeof value === "number") {
        return value;
    }
    return types_1.EasyEdaDocType.UNKNOWN;
}
function parseOptionalNumber(value, defaultValue) {
    if (typeof value === "string") {
        const num = parseFloat(value);
        return isNaN(num) ? defaultValue : num;
    }
    if (typeof value === "number") {
        return value;
    }
    return defaultValue;
}
function parseHead(json) {
    if (!json || typeof json !== "object") {
        return {
            docType: types_1.EasyEdaDocType.UNKNOWN,
            editorVersion: "",
            title: "",
            description: "",
            x: 0,
            y: 0,
            c_para: undefined,
        };
    }
    const obj = json;
    return {
        docType: parseDocType(obj["docType"]),
        editorVersion: String(obj["editorVersion"] ?? ""),
        title: String(obj["title"] ?? ""),
        description: String(obj["description"] ?? ""),
        x: parseOptionalNumber(obj["x"], 0),
        y: parseOptionalNumber(obj["y"], 0),
        c_para: obj["c_para"] && typeof obj["c_para"] === "object" ? obj["c_para"] : undefined,
    };
}
function parseDocument(json) {
    const parsedJson = typeof json === "string" ? JSON.parse(json) : json;
    const topObj = parsedJson;
    const dataObj = !topObj["head"] && topObj["dataStr"] && typeof topObj["dataStr"] === "object"
        ? topObj["dataStr"]
        : topObj;
    const head = parseHead(dataObj["head"]);
    const shapeRaw = dataObj["shape"];
    let shape = [];
    if (Array.isArray(shapeRaw)) {
        shape = shapeRaw.map((s) => String(s));
    }
    return {
        docType: topObj["docType"] !== undefined ? parseDocType(topObj["docType"]) : undefined,
        head,
        canvas: String(dataObj["canvas"] ?? ""),
        title: String(topObj["title"] ?? dataObj["title"] ?? ""),
        shape,
        dataStr: topObj["dataStr"],
    };
}
function parseDocumentPcb(json) {
    const obj = json;
    const layersRaw = obj["layers"];
    let layers = [];
    if (Array.isArray(layersRaw)) {
        layers = layersRaw.map((l) => String(l));
    }
    return {
        c_para: obj["c_para"] && typeof obj["c_para"] === "object" ? obj["c_para"] : undefined,
        layers,
        uuid: obj["uuid"] !== undefined ? String(obj["uuid"]) : undefined,
        DRCRULE: obj["DRCRULE"] && typeof obj["DRCRULE"] === "object"
            ? obj["DRCRULE"]
            : undefined,
    };
}
function parseDocumentSym(json) {
    const obj = json;
    return {
        c_para: obj["c_para"] && typeof obj["c_para"] === "object" ? obj["c_para"] : undefined,
    };
}
function parseDocumentSchematics(json) {
    const obj = json;
    let schematics;
    if (Array.isArray(obj["schematics"])) {
        schematics = obj["schematics"].map(parseDocument);
    }
    return { schematics };
}
const LINE_STYLE_TABLE = {
    "0": types_1.EasyEdaLineStyle.SOLID,
    "1": types_1.EasyEdaLineStyle.DASH,
    "2": types_1.EasyEdaLineStyle.DOT,
};
function convertLineStyle(style) {
    return LINE_STYLE_TABLE[style] ?? types_1.EasyEdaLineStyle.SOLID;
}
const ELEC_TYPE_TABLE = {
    "0": types_1.EasyEdaPinType.UNSPECIFIED,
    "1": types_1.EasyEdaPinType.INPUT,
    "2": types_1.EasyEdaPinType.OUTPUT,
    "3": types_1.EasyEdaPinType.BIDIRECTIONAL,
    "4": types_1.EasyEdaPinType.PASSIVE,
};
function convertElecType(typeStr) {
    return ELEC_TYPE_TABLE[typeStr] ?? types_1.EasyEdaPinType.UNSPECIFIED;
}
function safeFloat(str) {
    if (!str || str === "")
        return 0;
    const val = parseFloat(str);
    return isNaN(val) ? 0 : val;
}
function splitTilde(str) {
    return str.split("~");
}
function unescapeHtml(text) {
    return text
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&#x27;/g, "'")
        .replace(/&#x2F;/g, "/");
}
function parsePcbShape(shapeStr) {
    const arr = splitTilde(shapeStr);
    const elType = arr[0];
    if (elType === "LIB") {
        const fullShape = shapeStr.replace(/#@\$/g, "\n");
        const parts = fullShape.split("\n");
        if (parts.length < 1)
            return undefined;
        const paramsRoot = splitTilde(parts[0]);
        if (paramsRoot.length < 4)
            return undefined;
        const origin = {
            x: safeFloat(paramsRoot[1]),
            y: safeFloat(paramsRoot[2]),
        };
        let packageName = `Unknown_${paramsRoot[1]}_${paramsRoot[2]}`;
        const paramParts = (paramsRoot[3] ?? "").split("`");
        const params = {};
        for (let i = 1; i < paramParts.length; i += 2) {
            const key = paramParts[i - 1];
            const value = paramParts[i];
            if (key === "package")
                packageName = value;
            params[key] = value;
        }
        let orientation = 0;
        if (paramsRoot[4] && paramsRoot[4] !== "") {
            orientation = safeFloat(paramsRoot[4]);
        }
        let layer = 1;
        if (paramsRoot[7] && paramsRoot[7] !== "") {
            layer = safeFloat(paramsRoot[7]);
        }
        return {
            type: "LIB",
            origin,
            packageName,
            orientation,
            layer,
            params,
            shapes: parts.slice(1),
        };
    }
    if (elType === "TRACK") {
        const width = safeFloat(arr[1]);
        const layer = arr[2] ?? "";
        const netName = arr[3] ?? "";
        const data = (arr[4] ?? "").split(" ");
        const points = [];
        for (let i = 1; i < data.length; i += 2) {
            points.push({ x: safeFloat(data[i - 1]), y: safeFloat(data[i]) });
        }
        return { type: "TRACK", width, layer, netName, points };
    }
    if (elType === "CIRCLE") {
        return {
            type: "CIRCLE",
            center: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
            radius: safeFloat(arr[3]),
            width: safeFloat(arr[4]),
            layer: arr[5] ?? "",
            netName: arr[8] ?? "",
        };
    }
    if (elType === "RECT") {
        return {
            type: "RECT",
            start: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
            width: safeFloat(arr[3]),
            height: safeFloat(arr[4]),
            strokeWidth: safeFloat(arr[8]),
            layer: arr[5] ?? "",
            filled: arr[9] !== "none",
            netName: arr[11] ?? "",
        };
    }
    if (elType === "ARC") {
        const width = safeFloat(arr[1]);
        const layer = arr[2] ?? "";
        const netName = arr[3] ?? "";
        const data = arr[4] ?? "";
        let start = { x: 0, y: 0 };
        let end = { x: 0, y: 0 };
        let radius = { x: 10, y: 10 };
        let isFar = false;
        let cw = false;
        const arcTokenRe = /[MA]|[-+]?(?:\d+\.?\d*|\.\d+)(?:[eE][-+]?\d+)?/g;
        const tokens = data.match(arcTokenRe) ?? [];
        let ti = 0;
        const nextNum = () => safeFloat(tokens[ti++]);
        while (ti < tokens.length) {
            const sym = tokens[ti++];
            if (sym === "M") {
                start = { x: nextNum(), y: nextNum() };
            }
            else if (sym === "A") {
                const rx = nextNum();
                const ry = nextNum();
                nextNum();
                isFar = nextNum() === 1;
                cw = nextNum() === 1;
                radius = { x: rx, y: ry };
                end = { x: nextNum(), y: nextNum() };
            }
        }
        const dx = end.x - start.x;
        const dy = end.y - start.y;
        const chordLen = Math.sqrt(dx * dx + dy * dy);
        const arm = Math.sqrt(Math.max(0.0, radius.x * radius.x - (chordLen * chordLen) / 4));
        const perpLen = chordLen;
        const sign = isFar !== cw ? arm : -arm;
        const center = perpLen > 0
            ? {
                x: start.x + dx / 2 + (-dy / perpLen) * sign,
                y: start.y + dy / 2 + (dx / perpLen) * sign,
            }
            : { x: start.x + dx / 2, y: start.y + dy / 2 };
        return {
            type: "ARC",
            width,
            layer,
            netName,
            start: cw ? end : start,
            end: cw ? start : end,
            center,
            clockwise: cw,
        };
    }
    if (elType === "VIA") {
        return {
            type: "VIA",
            center: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
            diameter: safeFloat(arr[3]),
            netName: arr[4] ?? "",
            drillDiameter: safeFloat(arr[5]) * 2,
        };
    }
    if (elType === "HOLE") {
        return {
            type: "HOLE",
            center: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
            diameter: safeFloat(arr[3]) * 2,
            uuid: arr[4] ?? "",
        };
    }
    if (elType === "PAD") {
        const padType = (arr[1] ?? "");
        let shape;
        if (padType === "ELLIPSE")
            shape = types_1.EasyEdaPadShape.ELLIPSE;
        else if (padType === "RECT")
            shape = types_1.EasyEdaPadShape.RECT;
        else if (padType === "OVAL")
            shape = types_1.EasyEdaPadShape.OVAL;
        else if (padType === "POLYGON")
            shape = types_1.EasyEdaPadShape.POLYGON;
        else
            shape = types_1.EasyEdaPadShape.OVAL;
        const polyPoints = [];
        if (shape === types_1.EasyEdaPadShape.POLYGON) {
            const data = (arr[10] ?? "").split(" ");
            for (let i = 1; i < data.length; i += 2) {
                polyPoints.push({
                    x: safeFloat(data[i - 1]),
                    y: safeFloat(data[i]),
                });
            }
        }
        return {
            type: "PAD",
            shape,
            center: { x: safeFloat(arr[2]), y: safeFloat(arr[3]) },
            size: { x: safeFloat(arr[4]), y: safeFloat(arr[5]) },
            layer: arr[6] ?? "",
            netName: arr[7] ?? "",
            number: arr[8] ?? "",
            holeDiameter: arr[9] ? safeFloat(arr[9]) * 2 : 0,
            rotation: safeFloat(arr[11]),
            plated: arr[15] === "Y",
            points: polyPoints,
            holeLength: safeFloat(arr[13]),
            pasteExpansion: safeFloat(arr[17]),
            maskExpansion: safeFloat(arr[18]),
        };
    }
    if (elType === "TEXT") {
        const layer = arr[7] ?? "";
        const layerNum = parseInt(layer, 10);
        const isBack = layerNum === 2 || layerNum === 4 || layerNum === 6 || layerNum === 8 || layerNum === 14;
        const textStr = (arr[10] ?? "").replace(/\\n/g, "\n");
        return {
            type: "TEXT",
            textType: arr[1] ?? "",
            position: { x: safeFloat(arr[2]), y: safeFloat(arr[3]) },
            thickness: safeFloat(arr[4]),
            rotation: safeFloat(arr[5]),
            layer,
            height: safeFloat(arr[9]) * 0.8,
            text: unescapeHtml(textStr),
            font: arr[14] ?? "",
            mirror: isBack,
        };
    }
    if (elType === "SOLIDREGION") {
        return {
            type: "SOLIDREGION",
            layer: arr[1] ?? "",
            netName: arr[2] ?? "",
            pathData: (arr[3] ?? "").trim(),
            regionType: arr[4] ?? "",
        };
    }
    if (elType === "COPPERAREA") {
        return {
            type: "COPPERAREA",
            strokeWidth: safeFloat(arr[1]),
            layer: arr[2] ?? "",
            netName: arr[3] ?? "",
            pathData: (arr[4] ?? "").trim(),
            clearance: safeFloat(arr[5]),
            thermalType: arr[8] ?? "",
            keepIsland: arr[9] === "yes",
            fillData: arr[10] ?? "",
            fillOrder: parseInt(arr[13] ?? "0", 10),
            improveFabrication: arr[17] ?? "",
            spokeWidth: arr.length > 18 ? safeFloat(arr[18]) : 0,
        };
    }
    if (elType === "DIMENSION") {
        return {
            type: "DIMENSION",
            layer: arr[1] ?? "",
            shapeData: (arr[2] ?? "").trim(),
            lineWidth: safeFloat(arr[7]),
        };
    }
    if (elType === "SVGNODE") {
        try {
            const nodeData = JSON.parse(arr[1] ?? "{}");
            return {
                type: "SVGNODE",
                nodeType: typeof nodeData["nodeType"] === "number" ? nodeData["nodeType"] : 0,
                layer: String(nodeData["layerid"] ?? ""),
                attributes: nodeData["attrs"] && typeof nodeData["attrs"] === "object"
                    ? nodeData["attrs"]
                    : {},
            };
        }
        catch {
            return undefined;
        }
    }
    return undefined;
}
function parseSymbolShape(shapeStr) {
    const arr = splitTilde(shapeStr);
    const elType = arr[0];
    if (elType === "PL" || elType === "PG") {
        const ptArr = (arr[1] ?? "").split(" ");
        const points = [];
        for (let i = 1; i < ptArr.length; i += 2) {
            points.push({ x: safeFloat(ptArr[i - 1]), y: safeFloat(ptArr[i]) });
        }
        return {
            type: elType,
            points,
            strokeColor: arr[2] ?? "",
            lineWidth: safeFloat(arr[3]),
            lineStyle: convertLineStyle(arr[4] ?? "0"),
            fillColor: (arr[5] ?? "").toLowerCase(),
            closed: elType === "PG",
        };
    }
    if (elType === "PT") {
        return {
            type: "PT",
            pathData: arr[1] ?? "",
            strokeColor: arr[2] ?? "",
            lineWidth: safeFloat(arr[3]),
            lineStyle: convertLineStyle(arr[4] ?? "0"),
            fillColor: (arr[5] ?? "").toLowerCase(),
        };
    }
    if (elType === "A") {
        return {
            type: "A",
            pathData: arr[1] ?? "",
            strokeColor: arr[3] ?? "",
            lineWidth: safeFloat(arr[4]),
            lineStyle: convertLineStyle(arr[5] ?? "0"),
            fillColor: (arr[6] ?? "").toLowerCase(),
        };
    }
    if (elType === "R") {
        return {
            type: "R",
            start: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
            cornerRadius: { x: safeFloat(arr[3]), y: safeFloat(arr[4]) },
            size: { x: safeFloat(arr[5]), y: safeFloat(arr[6]) },
            strokeColor: arr[7] ?? "",
            lineWidth: safeFloat(arr[8]),
            lineStyle: convertLineStyle(arr[9] ?? "0"),
            fillColor: (arr[10] ?? "").toLowerCase(),
        };
    }
    if (elType === "E") {
        return {
            type: "E",
            center: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
            radius: { x: safeFloat(arr[3]), y: safeFloat(arr[4]) },
            strokeColor: arr[5] ?? "",
            lineWidth: safeFloat(arr[6]),
            lineStyle: convertLineStyle(arr[7] ?? "0"),
            fillColor: (arr[8] ?? "").toLowerCase(),
        };
    }
    if (elType === "P") {
        const sepShapeStr = shapeStr.replace(/\^\^/g, "\n");
        const segments = sepShapeStr.split("\n");
        if (segments.length < 5)
            return undefined;
        const mainParts = splitTilde(segments[0]);
        const pinDotParts = splitTilde(segments[1]);
        const pinPathColorParts = splitTilde(segments[2]);
        const pinNameParts = splitTilde(segments[3]);
        const pinNumParts = splitTilde(segments[4]);
        const pinType = convertElecType(mainParts[2] ?? "0");
        const pinNumber = pinNumParts[4] ?? mainParts[3] ?? "";
        const pinPos = {
            x: safeFloat(mainParts[4]),
            y: safeFloat(mainParts[5]),
        };
        const pinDotPos = {
            x: safeFloat(pinDotParts[0]),
            y: safeFloat(pinDotParts[1]),
        };
        const nameVisible = pinNameParts[0] !== "0";
        const pinName = pinNameParts[4] ?? "";
        const numVisible = pinNumParts[0] !== "0";
        let rotation = 0;
        let pinLen = 0;
        const pathResult = (0, svgPathParser_1.parsePinPathData)(pinPathColorParts[0] ?? "");
        if (pathResult) {
            pinLen = pathResult.pinLen;
            const { startPoint, vertical } = pathResult;
            if (!vertical) {
                if (startPoint.x === pinPos.x && pinLen < 0)
                    rotation = 180;
                else if (startPoint.x === pinPos.x && pinLen > 0)
                    rotation = 0;
                else if (startPoint.x !== pinPos.x && pinLen < 0)
                    rotation = 0;
                else if (startPoint.x !== pinPos.x && pinLen > 0)
                    rotation = 180;
            }
            else {
                if (startPoint.y === pinPos.y && pinLen < 0)
                    rotation = 90;
                else if (startPoint.y === pinPos.y && pinLen > 0)
                    rotation = 270;
                else if (startPoint.y !== pinPos.y && pinLen < 0)
                    rotation = 270;
                else if (startPoint.y !== pinPos.y && pinLen > 0)
                    rotation = 90;
            }
        }
        let hasDot = false;
        let hasClock = false;
        if (segments.length > 6) {
            const dotParts = splitTilde(segments[5]);
            const clockParts = splitTilde(segments[6]);
            if (dotParts.length === 3 && clockParts.length === 2) {
                hasDot = dotParts[0] === "1";
                hasClock = clockParts[0] === "1";
            }
        }
        return {
            type: "P",
            pinType,
            pinNumber,
            pinName,
            position: pinPos,
            dotPosition: pinDotPos,
            rotation,
            length: Math.abs(pinLen),
            nameVisible,
            numberVisible: numVisible,
            hasDot,
            hasClock,
        };
    }
    if (elType === "T") {
        const textStr = unescapeHtml((arr[11] ?? "").replace(/\\n/g, "\n"));
        return {
            type: "T",
            textType: arr[1] ?? "",
            position: { x: safeFloat(arr[2]), y: safeFloat(arr[3]) },
            angle: safeFloat(arr[4]),
            fontName: arr[6] ?? "",
            fontSize: arr[7] ?? "",
            baselineAlign: arr[9] ?? "",
            text: textStr,
            visible: arr[12] !== "0",
            horizontalAlign: arr[13] ?? "",
        };
    }
    if (elType === "Pimage") {
        return {
            type: "Pimage",
            start: { x: safeFloat(arr[6]), y: safeFloat(arr[7]) },
            size: { x: safeFloat(arr[8]), y: safeFloat(arr[9]) },
            imageUrl: arr[10] ?? "",
        };
    }
    return undefined;
}
function parseSchematicShape(shapeStr) {
    const fullShape = shapeStr.replace(/#@\$/g, "\n");
    const parts = fullShape.split("\n");
    if (parts.length < 1)
        return undefined;
    const arr = splitTilde(parts[0]);
    if (arr.length < 1)
        return undefined;
    const rootType = arr[0];
    if (rootType === "LIB") {
        if (arr.length < 4)
            return undefined;
        const origin = {
            x: safeFloat(arr[1]),
            y: safeFloat(arr[2]),
        };
        let symbolName = `Unknown_${arr[1]}_${arr[2]}`;
        const paramParts = (arr[3] ?? "").split("`");
        const params = {};
        for (let i = 1; i < paramParts.length; i += 2) {
            const key = paramParts[i - 1];
            const value = paramParts[i];
            if (key === "spiceSymbolName" && value !== "")
                symbolName = value;
            params[key] = value;
        }
        return {
            type: "LIB",
            origin,
            symbolName,
            params,
            shapes: parts.slice(1),
        };
    }
    if (rootType === "PL" || rootType === "PG") {
        const ptArr = (arr[1] ?? "").split(" ");
        const points = [];
        for (let i = 1; i < ptArr.length; i += 2) {
            points.push({ x: safeFloat(ptArr[i - 1]), y: safeFloat(ptArr[i]) });
        }
        return {
            type: rootType,
            points,
            strokeColor: arr[2] ?? "",
            lineWidth: safeFloat(arr[3]),
            lineStyle: convertLineStyle(arr[4] ?? "0"),
            fillColor: (arr[5] ?? "").toLowerCase(),
            closed: rootType === "PG",
        };
    }
    if (rootType === "W") {
        const ptArr = (arr[1] ?? "").split(" ");
        const points = [];
        for (let i = 1; i < ptArr.length; i += 2) {
            points.push({ x: safeFloat(ptArr[i - 1]), y: safeFloat(ptArr[i]) });
        }
        return {
            type: "W",
            points,
            strokeColor: arr[2] ?? "",
            lineWidth: safeFloat(arr[3]),
            lineStyle: convertLineStyle(arr[4] ?? "0"),
            fillColor: (arr[5] ?? "").toLowerCase(),
        };
    }
    if (rootType === "N") {
        return {
            type: "N",
            position: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
            angle: safeFloat(arr[3]),
            netName: arr[5] ?? "",
            horizontalAlign: arr[7] ?? "",
            textPosition: { x: safeFloat(arr[8]), y: safeFloat(arr[9]) },
        };
    }
    if (rootType === "O") {
        return {
            type: "O",
            position: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
        };
    }
    if (rootType === "J") {
        return {
            type: "J",
            position: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
        };
    }
    if (rootType === "F") {
        const sepShapeStr = parts[0].replace(/\^\^/g, "\n");
        const segments = sepShapeStr.split("\n");
        let netName = "";
        if (segments.length > 2) {
            const valueParts = splitTilde(segments[2]);
            netName = valueParts[0] ?? "";
        }
        return {
            type: "F",
            flagTypename: arr[1] ?? "",
            position: { x: safeFloat(arr[2]), y: safeFloat(arr[3]) },
            angle: safeFloat(arr[4]),
            netName,
        };
    }
    if (rootType === "T") {
        const textStr = unescapeHtml((arr[11] ?? "").replace(/\\n/g, "\n"));
        return {
            type: "T",
            position: { x: safeFloat(arr[2]), y: safeFloat(arr[3]) },
            angle: safeFloat(arr[4]),
            text: textStr,
            fontName: arr[6] ?? "",
            fontSize: arr[7] ?? "",
            baselineAlign: arr[9] ?? "",
            horizontalAlign: arr[13] ?? "",
        };
    }
    if (rootType === "R") {
        return {
            type: "R",
            start: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
            size: { x: safeFloat(arr[5]), y: safeFloat(arr[6]) },
            strokeColor: arr[7] ?? "",
            lineWidth: safeFloat(arr[8]),
            lineStyle: convertLineStyle(arr[9] ?? "0"),
            fillColor: (arr[10] ?? "").toLowerCase(),
            cornerRadius: { x: safeFloat(arr[3]), y: safeFloat(arr[4]) },
        };
    }
    if (rootType === "I") {
        return {
            type: "I",
            start: { x: safeFloat(arr[1]), y: safeFloat(arr[2]) },
            size: { x: safeFloat(arr[3]), y: safeFloat(arr[4]) },
            imageUrl: arr[6] ?? "",
            transformData: arr[9] ?? "",
        };
    }
    return undefined;
}
function parsePcbLayers(layerLines) {
    return layerLines.map((line) => {
        const parts = line.split("~");
        return {
            layerId: parseInt(parts[0] ?? "0", 10),
            layerName: parts[1] ?? "",
            layerColor: parts[2] ?? "",
            visible: parts[3] !== "false",
            active: parts[4] !== "false",
            enabled: parts[5] !== "false",
        };
    });
}
function parseDrcRules(rules) {
    if (!rules)
        return undefined;
    const defaultRules = rules["Default"];
    if (!defaultRules || typeof defaultRules !== "object")
        return undefined;
    const dr = defaultRules;
    const result = {};
    if (typeof dr["trackWidth"] === "number")
        result.trackWidth = dr["trackWidth"];
    if (typeof dr["clearance"] === "number")
        result.clearance = dr["clearance"];
    if (typeof dr["viaHoleD"] === "number")
        result.viaHoleD = dr["viaHoleD"];
    if (typeof dr["viaHoleDiameter"] === "number")
        result.viaHoleDiameter = dr["viaHoleDiameter"];
    return result;
}
function parseEasyEdaJson(jsonStr) {
    const json = JSON.parse(jsonStr);
    const doc = parseDocument(json);
    const docType = doc.docType ?? doc.head.docType;
    if (docType === types_1.EasyEdaDocType.PCB ||
        docType === types_1.EasyEdaDocType.PCB_MODULE ||
        docType === types_1.EasyEdaDocType.PCB_COMPONENT) {
        const pcbDoc = parseDocumentPcb(json);
        const layers = parsePcbLayers(pcbDoc.layers);
        const drcRules = parseDrcRules(pcbDoc.DRCRULE);
        const shapes = [];
        for (const shapeStr of doc.shape) {
            const shape = parsePcbShape(shapeStr);
            if (shape)
                shapes.push(shape);
        }
        return {
            type: "pcb",
            pcb: {
                docType,
                origin: { x: doc.head.x, y: doc.head.y },
                layers,
                drcRules,
                shapes,
                c_para: pcbDoc.c_para,
                uuid: pcbDoc.uuid,
            },
        };
    }
    if (docType === types_1.EasyEdaDocType.SYMBOL) {
        const symDoc = parseDocumentSym(json);
        const c_para = symDoc.c_para ?? doc.head.c_para;
        const symbolName = c_para?.["name"] ?? "Unknown";
        const symbolPrefix = c_para?.["pre"] ?? "";
        const symbolShapes = [];
        for (const shapeStr of doc.shape) {
            const shape = parseSymbolShape(shapeStr);
            if (shape)
                symbolShapes.push(shape);
        }
        return {
            type: "symbol",
            symbol: {
                docType,
                origin: { x: doc.head.x, y: doc.head.y },
                name: symbolName,
                prefix: symbolPrefix,
                params: c_para ?? {},
                shapes: symbolShapes,
            },
        };
    }
    if (docType === types_1.EasyEdaDocType.SCHEMATIC_SHEET || docType === types_1.EasyEdaDocType.SCHEMATIC_LIST) {
        const schDoc = parseDocumentSchematics(json);
        const allShapes = [];
        const allSymbols = [];
        const processShapeList = (shapeList) => {
            for (const shapeStr of shapeList) {
                const shape = parseSchematicShape(shapeStr);
                if (!shape)
                    continue;
                if (shape.type === "LIB") {
                    const symbolShapes = [];
                    for (const subShape of shape.shapes) {
                        const parsed = parseSymbolShape(subShape);
                        if (parsed)
                            symbolShapes.push(parsed);
                    }
                    let symbolName = shape.symbolName;
                    if (shape.params["spiceSymbolName"]) {
                        symbolName = shape.params["spiceSymbolName"];
                    }
                    allSymbols.push({
                        docType: types_1.EasyEdaDocType.SYMBOL,
                        origin: shape.origin,
                        name: symbolName,
                        prefix: shape.params["pre"] ?? shape.params["spicePre"] ?? "",
                        params: shape.params,
                        shapes: symbolShapes,
                    });
                }
                allShapes.push(shape);
            }
        };
        if (schDoc.schematics) {
            for (const subDoc of schDoc.schematics) {
                const subDocType = subDoc.docType ?? subDoc.head.docType;
                if (subDocType !== types_1.EasyEdaDocType.SCHEMATIC_SHEET)
                    continue;
                if (subDoc.dataStr) {
                    const dataStrDoc = parseDocument(subDoc.dataStr);
                    processShapeList(dataStrDoc.shape);
                }
                else {
                    processShapeList(subDoc.shape);
                }
            }
        }
        else {
            processShapeList(doc.shape);
        }
        return {
            type: "schematic",
            schematic: {
                docType,
                origin: { x: doc.head.x, y: doc.head.y },
                shapes: allShapes,
                symbols: allSymbols,
            },
        };
    }
    throw new Error(`Unsupported EasyEDA document type: ${docType}`);
}
//# sourceMappingURL=parser.js.map